import { Link, useLocation } from 'react-router';
import { appUrl } from '../lib/domains';

export default function MarketingNav() {
  const location = useLocation();

  const navItems = [
    { label: 'Home', path: '/' },
    { label: 'Statutes', path: '/statutes' },
    { label: 'How It Works', path: '/how-it-works' },
    { label: 'About Us', path: '/about' },
  ];

  const isActivePath = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  return (
    <nav className="fixed top-2 md:top-6 left-1/2 -translate-x-1/2 w-[96%] md:w-[90%] max-w-[1600px] z-50 flex h-14 items-center gap-2 md:gap-2.5">
      <Link
        to="/"
        discover="none"
        className="bg-[#333333] rounded-md flex h-14 w-[4.5rem] sm:w-20 items-center justify-center shrink-0 hover:bg-[#3d3d3d] transition-colors"
      >
        <div className="leading-none font-bold text-white text-[15px] sm:text-base tracking-tight flex flex-col items-center text-center">
          <span>Lex</span>
          <span>
            Gat<sup className="text-xs sm:text-sm font-medium leading-none -ml-1.5">®</sup>
          </span>
        </div>
      </Link>

      <div className="bg-[#333333] rounded-md hidden md:flex flex-1 h-14 items-stretch justify-center gap-6 lg:gap-10 px-6">
        {navItems.map((item) => {
          const active = isActivePath(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              discover="none"
              className={`relative flex items-center h-full px-3 text-sm font-normal transition-colors whitespace-nowrap ${
                active ? 'text-white' : 'text-neutral-300 hover:text-white'
              }`}
            >
              {item.label}
              {active && (
                <span className="absolute bottom-0 left-0 w-full h-[2px] bg-white" aria-hidden />
              )}
            </Link>
          );
        })}
      </div>

      <div className="md:hidden flex-1 min-w-0" aria-hidden />

      <div className="bg-[#333333] rounded-md flex h-14 items-center justify-center shrink-0 px-4 sm:px-5 gap-4 sm:gap-5">
        <a
          href={appUrl('/login')}
          className="text-sm font-normal text-neutral-300 hover:text-white transition-colors whitespace-nowrap"
        >
          Login
        </a>
        <a
          href={appUrl('/login')}
          className="btn-primary whitespace-nowrap px-5 py-1.5 text-sm font-medium"
        >
          Get Started
        </a>
      </div>
    </nav>
  );
}
